<template>
  <el-dialog title='出库'
             :visible.sync="dialog"
             :width="getIsMobile?'100%':'50%'"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :before-close="handleClose">
    <el-header ref="header" class="header">
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline">
        <div id="searchBox">
          <el-form-item label="" prop="xhname">
            <el-input placeholder="请输入型号" v-model="searchForm.xhname" @input="handleSearch(searchForm.xhname)" />
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="allChecked">完全匹配</el-checkbox>
          </el-form-item>
        </div>
      </el-form>
    </el-header>
   <div v-if="list.length>0">
     <div class="custom-table search-table" v-if="!childOutboundDialog">
       <el-table border fit highlight-current-row :data="list" :row-style="tableRowStyle"  @row-click="handleRowClick"
                 v-loading="listLoading" v-if="list.length">
         <el-table-column label="商品编码" prop="id" width="120"></el-table-column>
         <el-table-column label="型号" prop="xhname" width="160"></el-table-column>
         <el-table-column label="品牌" prop="source"></el-table-column>
         <el-table-column label="库存数量" prop="number"></el-table-column>
         <el-table-column label="进货价格" prop="price"></el-table-column>
         <el-table-column label="是否含税" prop="isshui">
           <template slot-scope="scope">
             <el-button  type="text" :style="scope.row.isshui == 'T' ? 'color: green':'color: red'"
                         :icon="scope.row.isshui == 'T' ?'el-icon-success':'el-icon-error'" style="font-size: 20px"/>
           </template>
         </el-table-column>
         <el-table-column label="库房货位" prop="kufang"></el-table-column>
         <el-table-column label="进货日期" prop="settime" width="120"></el-table-column>
         <el-table-column label="供应商" prop="gongyingshang" width="140"></el-table-column>
       </el-table>
       <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
                      :current-page="selectPage.pageNum" :page-sizes="[20, 50, 100, 200]"
                      :page-size="selectPage.pageSize"
                      background
                      layout="total, sizes, prev, pager, next, jumper" :total="allNum"
                      style="margin-top: 14px;margin-bottom:14px"
       >
       </el-pagination>
     </div>
     <ChildOutbound  v-else @close="handleChildClose" :parentId="parentId" :childId="childId" :outboundNum="outboundNum" :contractNum="contractNum" @outboundSuccess="getOutboundSuccess"/>
   </div>
    <el-empty :image-size="200" v-else/>
  </el-dialog>
</template>
<script>
import { defineComponent, reactive, ref,watch } from '@vue/composition-api'
import request from '@/utils/request'
import { Message } from 'element-ui'
import ChildOutbound from './childOutbound.vue'
import useRootSetting from '@/hooks/useRootSetting'
export default defineComponent({
  components: { ChildOutbound },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    parentId: {
      type: [Number,String],
      default: 0
    },
    xhName: {
      type: String,
      default: ''
    },
    contractNum: {
      type: [String,Number],
      default: 0
    }
  },
  setup(props, { emit }) {
    const {getIsMobile} = useRootSetting()
    const list = ref([])
    const searchForm = reactive({
      xhname: ''
    })
    const childOutboundDialog = ref(false)
    const listLoading = ref(false)
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20
    })
    const allNum = ref(1)
    const allChecked = ref(true)

    const pageSizeChange = (e) => {
      selectPage.pageSize = e
      getSearchOutbound(searchForm.xhname)
    }

    const pageCurrentChange = (e) => {
      selectPage.pageNum = e
      getSearchOutbound(searchForm.xhname)
    }

    const getSearchOutbound = (xhname) => {
      listLoading.value = true
      request({
        url: 'out_wareh_button.yy',
        method: 'get',
        params: { xhname: xhname,exact: allChecked.value,...selectPage }
      }).then(res => {
        if (res.code == 200) {
          listLoading.value = false
          list.value = res.data
          childOutboundDialog.value = false
          allNum.value = res.total
        }
      })
    }
    const handleSearch = (xhname) => {
      getSearchOutbound(xhname)
    }

    const tableRowStyle = ({ row }) => {
      if (row.col_type === 'T') {
        return { color: 'black' }
      } else {
        return { color: 'red' }
      }
    }

    const childId = ref(0)
    const outboundNum = ref(0)
    const handleRowClick = (row) => {
      childId.value = row.id
      if (row.col_type === 'F') {
          Message.error('型号被锁定不能出库或库存不足!')
      }else{
        childOutboundDialog.value = true
        outboundNum.value = row.number
      }
    }

    const handleClose = () => {
      emit('close')
    }

    const handleChildClose = () => {
      childOutboundDialog.value = false
    }

    //出库成功的回调，出库弹窗消失，然后再传给父级，调用父级列表的接口
   const getOutboundSuccess = (code) => {
      if(code == 200) {
        childOutboundDialog.value = false
        emit('outboundSuccess', code)
      }
   }

   watch(()=>props.dialog,(dialog)=>{
     if(dialog){
       searchForm.xhname = props.xhName
       handleSearch(searchForm.xhname)
     }
   })

    watch(allChecked,()=>{
      getSearchOutbound(searchForm.xhname)
    })

    return {
      allChecked,
      outboundNum,
      getIsMobile,
      childId,
      childOutboundDialog,
      listLoading,
      searchForm,
      list,
      allNum,
      selectPage,
      getSearchOutbound,
      pageSizeChange,
      pageCurrentChange,
      tableRowStyle,
      handleRowClick,
      handleClose,
      handleChildClose,
      handleSearch,
      getOutboundSuccess
    }
  }
})
</script>
<style lang="scss" scoped>
.el-header {
  margin: 0;
}

.search-table {
  max-height: 600px;
  overflow-y: scroll;
}

</style>


